'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _FacebookProvider = require('./FacebookProvider');

var _FacebookProvider2 = _interopRequireDefault(_FacebookProvider);

var _getCurrentHref = require('./utils/getCurrentHref');

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Feed = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Feed, _Component);

  function Feed() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Feed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClick = function (evn) {
      evn.preventDefault();
      evn.stopPropagation();

      var href = _this.getSharerHref();
      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height;


      var halfWidth = Math.floor(width / 2);
      var halfHeight = Math.floor(height / 2);

      var left = Math.floor(window.innerWidth / 2 - halfWidth);
      var top = Math.floor(window.innerHeight / 2 - halfHeight);

      var params = 'status=0, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0';

      window.open(href, 'sharer', params);

      var children = _this.props.children;

      if (children && children.props && children.props.onClick) {
        children.props.onClick(evn);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Feed.prototype.getSharerHref = function getSharerHref() {
    var facebook = this.context.facebook;
    var _props = this.props,
        _props$appId = _props.appId,
        appId = _props$appId === undefined ? facebook.props.appId : _props$appId,
        redirectURI = _props.redirectURI,
        display = _props.display,
        from = _props.from,
        to = _props.to,
        _props$link = _props.link,
        link = _props$link === undefined ? (0, _getCurrentHref2.default)() : _props$link,
        picture = _props.picture,
        source = _props.source,
        name = _props.name,
        caption = _props.caption,
        description = _props.description,
        ref = _props.ref;


    var query = _qs2.default.stringify({
      app_id: appId,
      redirect_uri: redirectURI,
      display: display,
      from: from,
      to: to,
      link: link,
      picture: picture,
      source: source,
      name: name,
      caption: caption,
      description: description,
      ref: ref
    });

    return '//www.facebook.com/dialog/feed?' + query;
  };

  Feed.prototype.render = function render() {
    var children = this.props.children;


    return _react2.default.cloneElement(children, { onClick: this.onClick });
  };

  return Feed;
}(_react.Component), _class.contextTypes = (0, _extends3.default)({}, _FacebookProvider2.default.childContextTypes), _class.propTypes = {
  children: _propTypes2.default.node,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  appId: _propTypes2.default.string,
  redirectURI: _propTypes2.default.string,
  display: _propTypes2.default.string.isRequired,
  from: _propTypes2.default.string,
  to: _propTypes2.default.string,
  link: _propTypes2.default.string,
  source: _propTypes2.default.string,
  picture: _propTypes2.default.string, // deprecated
  name: _propTypes2.default.string, // deprecated
  caption: _propTypes2.default.string, // deprecated
  description: _propTypes2.default.string, // deprecated
  ref: _propTypes2.default.string
}, _class.defaultProps = {
  display: 'popup',
  width: 626,
  height: 436,
  buttonClassName: 'btn btn-lg',
  iconClassName: 'fa fa-facebook pull-left',
  icon: true
}, _temp2);
exports.default = Feed;


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/Feed.js
// module id = 1603
// module chunks = 1